import type { MouseEvent } from 'react';

import { CoreTagProps } from '../shared/types/tag.types';

export type TagType = 'promotion' | 'promotionLink' | 'roundel';

// Mapping for size prop of CoreTag to the size values used in the API response
export enum CoreTagMapping {
  sm = 'small',
  md = 'medium',
}
export interface MultiBuyPriceProps {
  label: string;
  secondaryLabel: string;
  url?: string;
}

export interface RoundelProps {
  imageUrl: string;
  fallbackImageUrl?: string;
  alt?: string;
  url?: string;
}

export type TagModelMap = {
  promotion: CoreTagProps;
  promotionLink: MultiBuyPriceProps;
  roundel: RoundelProps;
};

export type FeatureTagZoneProps<T extends TagType> = {
  customStyles?: string;
  direction?: 'horizontal' | 'vertical';
  type?: T;
  maxTagsToShow?: number;
  model: TagModelMap[T][];
  onLinkClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};
